import PropTypes from "prop-types";
import { components } from "react-select";

export const MultiValue = (props) => {
    const { index, getValue } = props;
    const selectedValues = getValue();
    if (index < 3) {
    return <components.MultiValue {...props} />;
    }

    if (index === 3) {
    const remaining = selectedValues.length - 3;
    return (
        <components.MultiValue {...props}>
            <span>+{remaining} is selected</span>
        </components.MultiValue>
    );
    }
    return null;
};

MultiValue.propTypes = {
  index: PropTypes.number.isRequired,
  getValue: PropTypes.func.isRequired,
};
